import React, { useEffect, useState, useRef } from "react";
import { Col, Card, Table, Alert, Spinner, Modal,Dropdown } from "react-bootstrap";
import { Link } from "react-router-dom";
import Baseurl from "../../../Baseurl";
import axios from "axios";
import { useHistory } from "react-router-dom";
import swal from "sweetalert";
function ApproveExperts() {
  var history = useHistory();
  const sort = 10;
  const activePag = useRef(0);
  const [ownerDetails, setOwnerDetails] = useState([]);
  const [data, setData] = useState([]);
  const [searchData, setSearchData] = useState([]);
  const [spinner, setSpinner] = useState(true);
  const [show, setShow] = useState(false);
  const [ownerId, setOwnerId] = useState("");
  const [test, settest] = useState(0);
  function getData() {
    axios
      .get(
        Baseurl.baseurl5 +
          `/go-home-service/home-service-owner/get-all-approval-home-service-details`
      )
      .then((res) => {
        console.log("cbdkjfhfhrrrfffrn nfrjk", res.data.data);
        if(res.data.status){
            setOwnerDetails(res.data.data);
            setSearchData(res.data.data);
            setData(document.querySelectorAll("#job_data tbody tr"))
        }
        setSpinner(false);
       
      })
      .catch((err) => {});
  }
  const chageData = (frist, sec) => {
    for (var i = 0; i < data.length; ++i) {
      if (i >= frist && i < sec) {
        data[i].classList.remove("d-none");
      } else {
        data[i].classList.add("d-none");
      }
    }
  };
  activePag.current === 0 && chageData(0, sort);
  let paggination = Array(Math.ceil(data.length / sort))
    .fill()
    .map((_, i) => i + 1);
  const onClick = (i) => {
    activePag.current = i;
    chageData(activePag.current * sort, (activePag.current + 1) * sort);
    settest(i);
  };

  useEffect(() => {
    getData();
  }, []);

  const svg1 = (
    <svg width="20px" height="20px" viewBox="0 0 24 24" version="1.1">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <rect x="0" y="0" width="24" height="24"></rect>
        <circle fill="#000000" cx="5" cy="12" r="2"></circle>
        <circle fill="#000000" cx="12" cy="12" r="2"></circle>
        <circle fill="#000000" cx="19" cy="12" r="2"></circle>
      </g>
    </svg>
  );

  function searchRider(value) {
    let filteredData = [];
    if (searchData) {
      searchData.map((val) => {
        let phoneString = val.riderPhone.toString();
        if (
          val.riderFirstName.toLowerCase().includes(value) ||
          val.riderLastName.toLowerCase().includes(value) ||
          val.riderEmail.toLowerCase().includes(value) ||
          phoneString.includes(value)
        ) {
          filteredData.push(val);
        }
      });
      setOwnerDetails(filteredData);
    }
  }
  function blockOwner() {
    const artical = { ownerID: ownerId };
    axios
      .put(`${Baseurl.baseurl4}/go-food-super-admin/block-owner-food`, artical)
      .then((response) => {
        if (response.data.status) {
          console.log('result',response)
          getData();
          swal("Blocked", response.data.messgae, "success", {
            button: "Done",
            timer: 1000,
          });
        } else {
          swal("Oops", response.data.messgae, "error", {
            button: "Done",
            timer: 1000,
          });
        }
        setShow(false);
      })
      .catch((err) => {
        // if(err.toString()==="Error: Network Error")
        // {
        //   history.push('/offline')
        // }
        // else
        // {
        //   history.push('/400')
        // }
      });
  }
  return (
    <Col lg={12}>
      <Modal
        size="lg"
        show={show}
        onHide={() => {
          setShow(false);
        }}
      >
        <Modal.Body>
          <h4>Are You sure !! you want to block the owner ?</h4>
        </Modal.Body>
        <Modal.Footer>
          <button
            onClick={() => {
              blockOwner();
            }}
            className="btn btn-primary"
          >
            Block
          </button>
        </Modal.Footer>
      </Modal>
      <Card
        style={{
          color: "white",
          background:
            "linear-gradient(90deg, #135334 0%, #98e7c1 100%)",
        }}
      >
        <Card.Header>
          <div>
            <input
              type="text"
              className="form-control"
              placeholder="Search here..."
              onChange={(e) => {
                searchRider(e.target.value);
              }}
            />
          </div>
        </Card.Header>
        <Card.Body>
          <div id="job_data" className="dataTables_wrapper ">
            {spinner ? (
              <div className="text-center">
                <Spinner animation="border" variant="primary" />
              </div>
            ) : (
              <Table className="text-white" responsive>
                <thead>
                  <tr>
                    <th>
                      <strong>SL NO.</strong>
                    </th>

                    <th>
                      <strong>NAME</strong>
                    </th>
                    <th>
                      <strong>Company Name</strong>
                    </th>
                    <th>
                      <strong>Phone No.</strong>
                    </th>

                    <th>
                      <strong>Address</strong>
                    </th>
                    <th>
                      <strong>Action</strong>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {ownerDetails &&
                    ownerDetails.map((val, key) => (
                      <tr key={val._id}>
                        <td>{key + 1}</td>
                        <td>{val.Name}</td>
                        <td>{val.CompanyName}</td>
                        <td>{val.Phone}</td>
                        <td>{val.CompanyAddress}</td>
                       
                        <td>
                          <Dropdown>
                            <Dropdown.Toggle
                              variant="warning"
                              className="light sharp i-false"
                            >
                              {svg1}
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                              <Dropdown.Item
                                onClick={() => {
                                  history.push({pathname:`View-Experts/${val._id}`,state:val});
                                }}
                              >
                                View
                              </Dropdown.Item>
                            
                            </Dropdown.Menu>
                          </Dropdown>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </Table>
            )}
            {!ownerDetails && (
              <Alert
                variant="success"
                className="alert-dismissible fade show text-center"
              >
                Zero ownerDetails
              </Alert>
            )}
            <div className="d-sm-flex text-center justify-content-between align-items-center mt-3">
              <div className="dataTables_info text-white">
                Showing {activePag.current * sort + 1} to{" "}
                {data.length > (activePag.current + 1) * sort
                  ? (activePag.current + 1) * sort
                  : data.length}{" "}
                of {data.length} entries
              </div>
              <div
                className="dataTables_paginate paging_simple_numbers"
                id="example5_paginate"
              >
                <Link
                  className="paginate_button previous disabled"
                  onClick={() =>
                    activePag.current > 0 && onClick(activePag.current - 1)
                  }
                >
                  Previous
                </Link>
                <span>
                  {paggination.map((number, i) => (
                    <Link
                      key={i}
                      className={`paginate_button  ${
                        activePag.current === i ? "current" : ""
                      } `}
                      onClick={() => onClick(i)}
                    >
                      {number}
                    </Link>
                  ))}
                </span>
                <Link
                  className="paginate_button next"
                  onClick={() => {
                    activePag.current + 1 < paggination.length &&
                      onClick(activePag.current + 1);
                  }}
                >
                  Next
                </Link>
              </div>
            </div>
          </div>
        </Card.Body>
      </Card>
    </Col>
  );
}

export default ApproveExperts;
